import styled from "styled-components";

export const ModalRegistrationWrapper = styled.div`
  .content-flex {
    display: flex;
    padding: 24px;
    max-width: 890px;
    background: #fff;
    background-position: 0;
    height: 472px;
    margin: auto;
  }
  .content-popup {
    height: 420px;
    width: 50%;
    overflow: unset;
    margin-right: 37px;
    margin-top: 0px;
  }
`;
